// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.line-style-editor {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px 16px;
  justify-content: flex-end;
}

.line-style-editor-label {
  color: var(--text-secondary);
}

.line-style-thickness .select-dropdown-trigger {
  min-width: 53px;
}

.line-style-type .select-dropdown-trigger {
  min-width: 80px;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/components/common/LineStyleEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".line-style-editor {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 16px 16px;\n  justify-content: flex-end;\n}\n\n.line-style-editor-label {\n  color: var(--text-secondary);\n}\n\n.line-style-thickness .select-dropdown-trigger {\n  min-width: 53px;\n}\n\n.line-style-type .select-dropdown-trigger {\n  min-width: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
